export enum RccapRecipientNotReady {    
    RecipientSick = 0,
    RecipientBackedOut = 1,
    RecipientNotReady = 2,
    RecipientNotAvailable = 3
}